import React, { useState, useEffect } from "react";
import "./main_dashboard.css";
import "./dashboard_new.css";
import Top_navbar from "./Top_navbar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages } from '@fortawesome/free-regular-svg-icons';
import { decryptData } from "../../controllers/Encryption";
import { useNavigate } from "react-router-dom";
import {
  faBoxes, faBullhorn, faCircleUser, faCogs, faCubes,
  faFileInvoice, faFileInvoiceDollar, faGifts, faListCheck,
  faListNumeric, faMoneyBill, faMoneyBill1Wave, faMoneyBillTrendUp,
  faReceipt, faTicket, faTrophy, faUser, faWallet, faWarehouse,
  faUserShield, faArrowRightFromBracket, faChartBar, faClipboardList,
  faTicketAlt, faHandHoldingDollar
} from "@fortawesome/free-solid-svg-icons";

const NAV_ITEMS = [
  // Accounts
  { link: `/sub-admin/list`,           icon: faUserShield,          title: `Sub Admin`,            description: `Manage sub-admin accounts`,     permission: null,                                  color: '#6366f1', bg: '#eef2ff', superOnly: true },
  { link: `/users/list`,               icon: faCircleUser,          title: `Users`,                description: `View and manage all users`,     permission: 'usersPermission.list',                color: '#3b82f6', bg: '#eff6ff' },
  // Requests
  { link: `/users/request-list`,       icon: faClipboardList,       title: `User Requests`,        description: `New user onboarding requests`,  permission: 'userRequest.list',                    color: '#f97316', bg: '#fff7ed' },
  { link: `/request/pull-out-list`,    icon: faArrowRightFromBracket, title: `Pull-Out Requests`, description: `User pull-out request queue`,    permission: 'userPullOutRequest.list',             color: '#ef4444', bg: '#fef2f2' },
  // Finance
  { link: `/recharge/b-point-list`,    icon: faMoneyBill,           title: `B-Points`,             description: `B-Point recharge history`,      permission: 'rechargePoints.list',                 color: '#10b981', bg: '#ecfdf5' },
  { link: `/transactions/list`,        icon: faHandHoldingDollar,   title: `Transactions`,         description: `View all transactions`,         permission: 'transactions.list',                   color: '#059669', bg: '#d1fae5' },
  { link: `/wallets-statement/list`,   icon: faWallet,              title: `Wallet Statement`,     description: `Wallet transaction statements`, permission: 'walletStatement.list',                color: '#0d9488', bg: '#ccfbf1' },
  { link: `/invoice/list`,             icon: faFileInvoice,         title: `Invoice`,              description: `Individual invoice list`,       permission: 'individualInvoice.list',              color: '#0891b2', bg: '#e0f2fe' },
  { link: `/invoice/bulk-list`,        icon: faFileInvoiceDollar,   title: `Bulk Invoice`,         description: `Bulk invoice requests`,         permission: 'bulkInvoice.list',                    color: '#0284c7', bg: '#bae6fd' },
  // Promo
  { link: `/promocodes/list`,          icon: faGifts,               title: `Promo Codes`,          description: `Manage promo codes`,            permission: 'promoCodes.list',                     color: '#d97706', bg: '#fef3c7' },
  { link: `/promocodes/order`,         icon: faListCheck,           title: `Promo Code Orders`,    description: `Promo code order list`,         permission: 'promoCodesOrder.list',                color: '#b45309', bg: '#fef9c3' },
  { link: `/promocodes/vouchers/list`, icon: faTicket,              title: `Promo Vouchers`,       description: `Promo code vouchers`,           permission: 'promoCodesVoucher.list',              color: '#92400e', bg: '#fde68a' },
  // Products
  { link: `/product/list`,             icon: faBoxes,               title: `Products`,             description: `Navigate to products list`,     permission: 'products.list',                       color: '#7c3aed', bg: '#f5f3ff' },
  { link: `/product/variants/list`,    icon: faCubes,               title: `Product Variants`,     description: `Product variant management`,    permission: 'productVariant.list',                 color: '#6d28d9', bg: '#ede9fe' },
  { link: `/product/inventory/list`,   icon: faWarehouse,           title: `Inventory`,            description: `Manage product inventory`,      permission: 'productInventory.list',               color: '#5b21b6', bg: '#ddd6fe' },
  { link: `/product/order/list`,       icon: faReceipt,             title: `Product Orders`,       description: `View product order list`,       permission: 'productOrder.list',                   color: '#4c1d95', bg: '#c4b5fd' },
  // CMS
  { link: `/cms/general_data/addeditdata`, icon: faCogs,           title: `General Data`,         description: `Edit general site content`,     permission: 'generalDataCMS.edit',                 color: '#475569', bg: '#f1f5f9' },
  { link: `/cms/banner/list`,          icon: faImages,              title: `Banners`,              description: `Manage CMS banners`,            permission: 'bannerCMS.list',                      color: '#334155', bg: '#e2e8f0' },
  // Campaign
  { link: `/campaign/list`,            icon: faBullhorn,            title: `Campaign`,             description: `View and run campaigns`,        permission: 'campaign.list',                       color: '#db2777', bg: '#fdf2f8' },
  { link: `/campaign/order/list`,      icon: faListNumeric,         title: `Campaign Orders`,      description: `Campaign order history`,        permission: 'campaignOrder.list',                  color: '#be185d', bg: '#fce7f3' },
  { link: `/campaign/freezes`,         icon: faCogs,                title: `Campaign Freezes`,     description: `Manage campaign freeze dates`,  permission: 'campaignFreezes.edit',                color: '#9d174d', bg: '#fbcfe8' },
  // Raffle / Lotto
  { link: `/raffle-winners/list`,      icon: faTrophy,              title: `Raffle Winners`,       description: `Raffle winner records`,         permission: 'raffleWinner.list',                   color: '#ca8a04', bg: '#fefce8' },
  { link: `/raffle-draw/list`,         icon: faTrophy,              title: `Raffle Draws`,         description: `Raffle draw schedule`,          permission: 'raffleDraw.list',                     color: '#a16207', bg: '#fef9c3' },
  { link: `/lotto-winners/list`,       icon: faMoneyBill1Wave,      title: `Lotto Winners`,        description: `Lotto winner records`,          permission: 'lottoWinner.list',                    color: '#16a34a', bg: '#f0fdf4' },
  { link: `/lotto-winners/redeem-list`,icon: faMoneyBillTrendUp,    title: `Lotto Redeemed`,       description: `Lotto redemption history`,      permission: 'lottoRedeem.list',                    color: '#15803d', bg: '#dcfce7' },
  // Vouchers & Reports
  { link: `/winning-vouchers/list`,    icon: faTicketAlt,           title: `Winning Vouchers`,     description: `Manage winning vouchers`,       permission: 'winningVouchers.list',                color: '#0f766e', bg: '#ccfbf1' },
  { link: `/statistics-reports`,       icon: faChartBar,            title: `Statistics`,           description: `View statistics & reports`,     permission: 'statisticsReport.lotto',              color: '#0369a1', bg: '#e0f2fe' },
];

const getPermissionValue = (permissionData, path) => {
  if (!path || !permissionData) return 'N';
  const [group, key] = path.split('.');
  return permissionData?.[group]?.[key] === 'Y' ? 'Y' : 'N';
};

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
};

const Dashboard = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("ADMIN-INFO") || sessionStorage.getItem("AGENT-ADMIN-INFO"));
  const [PERMISSIONDATA, setPermissionData] = useState('');

  const handlePermission = async () => {
    if (user && user.admin_type !== 'Super Admin') {
      try {
        const raw = localStorage.getItem("ADMIN-PERMISSION") || sessionStorage.getItem("ADMIN-PERMISSION");
        if (!raw || raw === 'null') return;
        const encrypted = JSON.parse(raw);
        const decrypted = await decryptData(encrypted);
        setPermissionData(JSON.parse(decrypted));
      } catch (e) { /* silent */ }
    }
  };

  useEffect(() => {
    const raw = localStorage.getItem("ADMIN-PERMISSION") || sessionStorage.getItem("ADMIN-PERMISSION");
    if (raw && raw !== 'null') handlePermission();
  }, []);

  const isSuperAdmin = user?.admin_type === 'Super Admin';

  const visibleItems = NAV_ITEMS.filter(item => {
    if (item.superOnly) return isSuperAdmin;
    if (isSuperAdmin) return true;
    return getPermissionValue(PERMISSIONDATA, item.permission) === 'Y';
  });

  const today = new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <>
      <Top_navbar title="Dashboard" />
      <div className="dash-page">
        {/* Greeting banner */}
        <div className="dash-greeting">
          <div>
            <div className="dash-greeting-text">
              {getGreeting()}, <strong>{user?.admin_first_name || 'Admin'}</strong> 👋
            </div>
            <div className="dash-greeting-date">{today}</div>
          </div>
          <div className="dash-greeting-badge">
            {isSuperAdmin ? 'Super Admin' : (user?.department_name || 'Admin')}
          </div>
        </div>

        {/* Cards grid */}
        {visibleItems.length === 0 ? (
          <div className="dash-empty">No modules are assigned to your account yet.</div>
        ) : (
          <div className="dash-grid">
            {visibleItems.map((item, index) => (
              <div
                key={index}
                className="dash-card"
                onClick={() => navigate(item.link)}
                style={{ '--card-color': item.color, '--card-bg': item.bg }}
              >
                <div className="dash-card-icon">
                  <FontAwesomeIcon icon={item.icon} />
                </div>
                <div className="dash-card-body">
                  <div className="dash-card-title">{item.title}</div>
                  <div className="dash-card-desc">{item.description}</div>
                </div>
                <div className="dash-card-arrow">›</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Dashboard;
